module.exports = __webpack_public_path__ + "static/media/YF32_6.690dd43a.jpg";